export { default } from './OfferVerticalCard';
